import React, { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Grid, Slide, Typography, Button } from '@material-ui/core';
import useStyles from './styles';

import BarberShopTitle from '../../components/BarberShopTitle';
import ItemTier from '../../components/ItemTier';
import { IPlan } from '../../shared/interfaces/plan-interfaces';
import { useChoosePlan, useGetPlans } from '../../hooks/data/plans';
import { useAuth } from '../../hooks/auth';
import Loading from '../../components/Loading';

const SignUpPlan: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const { fetchUserData, signOut } = useAuth();

  const plansQuery = useGetPlans();
  const choosePlanMutation = useChoosePlan({});

  const handleClick = useCallback(
    (plan: IPlan) => () => {
      choosePlanMutation.mutateAsync(plan.id).then(() => {
        fetchUserData();
        history.push('/dashboard');
      });
    },
    [choosePlanMutation, fetchUserData, history],
  );

  const handleLogout = useCallback(() => {
    signOut();
    history.push('/');
  }, [history, signOut]);

  return (
    <Box display="flex" justifyContent="center" maxWidth="600px" margin="auto">
      <Slide in direction="left">
        <Box
          p={3}
          display="flex"
          flexDirection="column"
          width="100%"
          alignItems="center"
          textAlign="center"
          className={classes.root}
        >
          <BarberShopTitle title="Agendfly" />
          <Box component="main">
            <Typography
              component="h1"
              variant="h2"
              align="center"
              color="textPrimary"
              gutterBottom
            >
              Planos
            </Typography>
            <Typography
              variant="h5"
              align="center"
              color="textSecondary"
              component="p"
            >
              Escolha o plano que mais se adequa a suas expectativas
            </Typography>
          </Box>
          {plansQuery.status === 'loading' && <Loading />}

          <Grid
            container
            spacing={5}
            alignItems="flex-end"
            component="section"
            style={{ marginTop: '16px' }}
          >
            {plansQuery.status === 'success' &&
              plansQuery.data?.map(tier => (
                <Grid item key={tier.slug} xs={12}>
                  <ItemTier
                    tier={{
                      ...tier,
                      value: tier.value,
                      max_users: tier.max_users,
                    }}
                    buttonText="Selecionar"
                    buttonVariant="contained"
                    handleClick={handleClick(tier)}
                    loading={choosePlanMutation.isLoading}
                  />
                </Grid>
              ))}
          </Grid>
          <Button
            disabled={choosePlanMutation.isLoading}
            variant="outlined"
            color="primary"
            className={classes.submitButton}
            type="button"
            size="large"
            fullWidth
            onClick={handleLogout}
          >
            Cancelar
          </Button>
        </Box>
      </Slide>
    </Box>
  );
};

export default SignUpPlan;
